import axios from 'axios'
import store from './../../store'

import { AUTH_LOGOUT, TOGGLE_AUTH_POPUP } from './../../domains/authentication/store/actions'
import { DONE, PENDING, SHOW_TOAST_MESSAGE } from '../store/actions';
import GeneralVariables from './GeneralVariables';


axios.defaults.showLoader = true;
axios.defaults.authorization = true;



const axiosInstance = axios.create({
    baseURL: GeneralVariables.BACKEND + 'api/v1.0/',
    timeout: 120000,
});

axiosInstance.interceptors.request.use(
    config => {
        if (config.showLoader) {
            store.dispatch(PENDING);
        }
        if (config.url != "auth/login" && config.url != "auth/register" && config.url != "auth/refresh_token"&& store.getters.isAuthenticated && config.authorization == true) {
            config.headers['Authorization'] = "Bearer " + store.getters.token;
        }

        config.headers['currency'] = store.getters.currency != undefined ? store.getters.currency.code : 'USD'
        config.headers['country'] = store.getters.country != undefined? store.getters.country: 'France'
        config.headers['Accept-Language'] = store.getters.locale
        config.params = config.params || {};
        config.params['locale'] = store.getters.locale
        if (config.formData == true) {
            config.headers['Content-Type'] = 'multipart/form-data'
        } else {
            config.headers['Accept'] = 'application/json'
        }

        return config;
    },
    error => {
        if (error.config.showLoader) {
            store.dispatch(DONE);
        }
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    response => {
        if (response.status == 200 || response.status == 201) {

            if (response.config.message != undefined && response.config.message.success != undefined) {
                store.dispatch(SHOW_TOAST_MESSAGE, response.config.message.success)
            }

        }

        if (response.config.showLoader) {
            store.dispatch(DONE);
        }

        return response;
    },
    error => {
        let response = error;

        if (response.config.showLoader) {
            store.dispatch(DONE);
        }

        if (response.config.message && response.config.message.error)
            store.dispatch(SHOW_TOAST_MESSAGE, response.config.message.error)

        if ((error.response && error.response.data && error.response.data.message && error.response.data.message.includes("Keycloak Guard")) ||
            (error.response && error.response.config.url != 'auth/login' && error.response.status == 401)) {
            store.dispatch(AUTH_LOGOUT).then(() => {
                store.commit(TOGGLE_AUTH_POPUP, true);
            });
        }

        if ((error.response && error.response.data && error.response.data.message && error.response.data.message.includes("Keycloak Guard")) ||
            (error.response && error.response.config.url != 'auth/login' && error.response.status == 401)) {
            store.dispatch(AUTH_LOGOUT).then(() => {
                store.commit(TOGGLE_AUTH_POPUP, true);
            });
        }

        return Promise.reject(error);
    }
)

export default axiosInstance;